import { useMemo } from "react";

import { NetworkStatus, useQuery } from "@apollo/client";

import { GetUserByIdQuery, UserSettingsInput } from "../../API";
import { GET_CURRENT_USER } from "../operations/queries";
import {
  DEFAULT_CAMERA_FOV,
  DEFAULT_CONTROL_ROOM_REFRESH_MINUTES,
  DEFAULT_VIDEO_SPEED,
  DEFAULT_WINDSPEED_UNIT,
} from "../../leak-finder/hooks/useLazyGetUser";

export const useGetCurrentUser = () => {
  const { data, loading, refetch, networkStatus } = useQuery<GetUserByIdQuery>(
    GET_CURRENT_USER,
    {
      notifyOnNetworkStatusChange: true,
    }
  );
  const memoizedValue = useMemo(() => {
    let userSettings: UserSettingsInput | null = null;

    try {
      if (data?.getUserById.userSettings) {
        const settings = JSON.parse(data?.getUserById.userSettings);

        userSettings = {
          defaultCameraFov: settings?.defaultCameraFov ?? DEFAULT_CAMERA_FOV,
          defaultWindspeedUnit:
            settings?.defaultWindspeedUnit ?? DEFAULT_WINDSPEED_UNIT,
          defaultVideoSpeed: settings?.defaultVideoSpeed ?? DEFAULT_VIDEO_SPEED,
          controlRoomRefreshMinutes:
            settings?.controlRoomRefreshMinutes ??
            DEFAULT_CONTROL_ROOM_REFRESH_MINUTES,
        };

        return {
          ...data?.getUserById,
          userSettings: userSettings,
        };
      }
    } catch (error) {
      console.error(error);

      return {
        ...data?.getUserById,
        userSettings: null,
      };
    }
  }, [data]);

  return {
    userInfo: memoizedValue,
    loading: loading || networkStatus === NetworkStatus.refetch,
    refetch,
  };
};
